import React, { useState, useEffect } from 'react';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { LinearProgress } from '@mui/material';
import BasicForm from '../basicForm/basicForm';
import style from './preScreening.module.scss';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import ButtonContainer from '../buttonContainer/buttonContainer';
import colors from '../../../scss/colors';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 81,
  height: 29,
  padding: 0,
  marginBottom: 16,
  '& .Mui-checked+.MuiSwitch-track': {
    backgroundColor: `${colors.NAVY_BLUE}!important`,
    '&:before': {
      content: '"Yes"'
    },
    '&:after': {
      content: '""'
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    transform: 'translateX(51px)'
  },
  '& .MuiSwitch-track': {
    borderRadius: 18,
    opacity: '1!important',
    backgroundColor: `${colors.MEDIUM_GREY}!important`,
    '&:before, &:after': {
      color: colors.WHITE,
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
      fontFamily: 'Gotham',
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center'
    },
    '&:before': {
      content: '""',
      left: 16
    },
    '&:after': {
      content: '"No"',
      right: 16
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 20,
    height: 20,
    margin: -5,
    color: '#C4C4C4'
  }
}));

function PreScreening(props) {
  const [toggles, setToggle] = useState({});
  const { nextHandle, backHandle, cancel, questions, data, step, totalStep, jobTitle } = props;
  const { t } = useTranslation();

  const trQuestions = Object.values(questions).reduce((resultArray, question, index) => {
    if (!question) {
      return resultArray;
    }
    resultArray[index] = question;
    return resultArray;
  }, []);

  useEffect(() => {
    if (trQuestions.length === 0) {
      nextHandle(toggles);
    } else {
      const questObj = {};
      trQuestions.forEach((_, index) => {
        questObj[`Answer${index + 1}`] = false;
      });
      setToggle(questObj);

      if (questObj) {
        setToggle({ ...toggles, Answer1: data?.Answer1, Answer2: data?.Answer2, Answer3: data?.Answer3 });
      }
    }
  }, []);

  return (
    <BasicForm
      cancel={cancel}
      title={`${t('jobs.quickapply.userdetailheader')} ${jobTitle}`}
      progress="60"
      subtitle={t('jobs.quickapply.additionalquestions')}
      step={step}
      totalStep={totalStep}
    >
      {!trQuestions.length ? (
        <LinearProgress style={{ marginTop: 30 }} />
      ) : (
        <>
          {trQuestions.map((item, index) => (
            <React.Fragment key={`question${index + 1}`}>
              <label className={style.question} htmlFor="question">
                {item}
              </label>
              <div>
                <FormControlLabel
                  onChange={(e) => {
                    setToggle({ ...toggles, [`Answer${index + 1}`]: e.target.checked });
                  }}
                  checked={toggles[`Answer${index + 1}`]}
                  id={`question${index + 1}`}
                  control={<CustomSwitch />}
                  label=""
                  sx={{
                    marginLeft: '0',
                    marginTop: '10px',
                    marginBottom: '10px'
                  }}
                />
              </div>
            </React.Fragment>
          ))}
          <ButtonContainer
            actionCall={() => nextHandle(toggles)}
            primaryText={t('common.general.back')}
            secondaryText={t('common.general.next')}
            back={backHandle}
          />
        </>
      )}
    </BasicForm>
  );
}

export default PreScreening;
